import { render, staticRenderFns } from "./RetrieveLoginId.vue?vue&type=template&id=0b81e518"
import script from "./RetrieveLoginId.vue?vue&type=script&lang=js"
export * from "./RetrieveLoginId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports